import React from 'react';
import ChevronRightSharpIcon from "@mui/icons-material/ChevronRightSharp";

const ViewIconRenderer = (params) => (
    <div>
      <ChevronRightSharpIcon
        /*onClick={(e) => {
          viewDetails(e, params);
        }}*/
      />
    </div>
  );
export default ViewIconRenderer;